{
  "version": 1,
  "asset_id": "f1616c86-0646-471a-bd28-6e04eed87f08",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/f1616c86-0646-471a-bd28-6e04eed87f08/destination-roofing-owner-dump-trailer-crystal-river-fl-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/f1616c86-0646-471a-bd28-6e04eed87f08/destination-roofing-owner-dump-trailer-crystal-river-fl-1320w.webp",
  "original_filename": "destination-roofing-owner-dump-trailer-crystal-river-fl-1320w.webp",
  "size": 112140,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:35Z"
}
